import 'userpilot'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import config from './config/config'
import { getEnabledQueues } from './utils/shopUtils'
import { joinByComma } from './utils/ArrayUtils'
import { ISession } from 'models/interfaces/session'

const Userpilot = (window as any).Userpilot

export function setupUserpilot(): void {
  console.log('[Userpilot] Configuring for ' + config.NODE_ENV)

  if (!config.userpilotToken) {
    console.log('[Userpilot] No token configured. Skipping.')
    return
  }

  try {
    Userpilot.initialize(config.userpilotToken)
    console.log('[Userpilot] Configured for ' + config.NODE_ENV)
  } catch (e) {
    console.warn('[Userpilot] initialize failed', e)
  }
}

export function identifyUserpilotUser(session?: ISession): void {
  if (!session || !config.userpilotToken) return

  const {
    employee: user,
    company,
    assignedShop: shop,
    shops: companyShops,
    employeeShops,
    numberOfEmployees,
  } = session

  if (!user?.id) return

  const enabledQueues = shop ? getEnabledQueues(shop) : ''
  const enabledShopIds = joinByComma(employeeShops, (s) => s?.id)
  const enabledShops = joinByComma(employeeShops, (s) => s?.name)
  const organizationIds = joinByComma(user.organizationIds, (o) => o)

  /* eslint-disable @typescript-eslint/camelcase */
  const companyPayload = company
    ? {
        id: company.id,
        name: company.name,
        state: company.address?.state,
        productSKU: company.productSKU,
        number_of_shops: companyShops?.length ?? 0,
        number_of_employees: numberOfEmployees,
      }
    : undefined

  const attrs: Record<string, any> = {
    name: user.name,
    email: user.email,
    role: user.role?.name,
    phone_number: user.phoneNumber,
    last_login: user.lastLoginTime,
    driver: user.driver,
    packer: user.packer,
    enabled_shop_list_ids: enabledShopIds,
    enabled_shop_list: enabledShops,
    organization_ids: organizationIds,
    internal: user.internal,
    blaze_admin: user.isBlazeAdmin,
    created_at: user.created,
    ...(shop && {
      shop_id: shop.id,
      shop_name: shop.name,
      shop_state: shop.address?.state,
      shop_city: shop.address?.city,
      shop_type: shop.shopType,
      shop_license: shop.license,
      shop_enabled_queues: enabledQueues,
    }),
    ...(companyPayload ? { company: companyPayload } : {}),
  }
  /* eslint-enable @typescript-eslint/camelcase */

  try {
    Userpilot.identify(user.id, attrs)
  } catch (e) {
    console.warn('[Userpilot] identify failed', e)
  }
}

export function reloadUserpilot(): void {
  if (!config.userpilotToken) return
  try {
    Userpilot.reload()
  } catch (e) {
    console.warn('[Userpilot] reload failed', e)
  }
}

export function trackUserPilotEvent(eventName: string, properties?: Record<string, any>): void {
  if (!config.userpilotToken) return
  try {
    Userpilot.track(eventName, properties)
  } catch (e) {
    console.warn('[Userpilot] track failed', e)
  }
}



// WEBPACK FOOTER //
// ./src/userpilotClient.ts